import createIcon from "../createIcon"

export const ChevronDownIcon = (props) => {
  return createIcon({
    size: props.size,
    path : <path fillRule="evenodd" clipRule="evenodd" d="M18.7722 8.23431C18.4685 7.9219 17.976 7.9219 17.6723 8.23431L12 14.0686L6.32775 8.23431C6.02401 7.92189 5.53155 7.92189 5.22781 8.23431C4.92407 8.54673 4.92407 9.05327 5.22781 9.36568L11.45 15.7657C11.7538 16.0781 12.2462 16.0781 12.55 15.7657L18.7722 9.36568C19.0759 9.05327 19.0759 8.54673 18.7722 8.23431Z" fill="#1A1818"/>
  })
} 